module.exports = __webpack_public_path__ + "img/concerned_about_vaccination.ebb301da.svg";